// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chameleon .p3sdk-target{background:#efefef}`, "",{"version":3,"sources":["webpack://./chameleon/legacy/src/components/VideoModal/3PlayPlugin/index.scss"],"names":[],"mappings":"AAAA,yBACE,kBAAA","sourcesContent":[".p3sdk-target {\n  background: #efefef;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
